import { render, staticRenderFns } from "./orderAbnormal.vue?vue&type=template&id=af91f200&scoped=true"
import script from "./orderAbnormal.vue?vue&type=script&lang=js"
export * from "./orderAbnormal.vue?vue&type=script&lang=js"
import style0 from "./orderAbnormal.vue?vue&type=style&index=0&id=af91f200&prod&scoped=true&lang=css"
import style1 from "./orderAbnormal.vue?vue&type=style&index=1&id=af91f200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af91f200",
  null
  
)

export default component.exports